var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0 reversed", attrs: { fluid: "" } },
    [
      _c(
        "v-window",
        {
          model: {
            value: _vm.windowIndex,
            callback: function($$v) {
              _vm.windowIndex = $$v
            },
            expression: "windowIndex"
          }
        },
        [
          _c(
            "v-window-item",
            { attrs: { value: 1 } },
            [
              _c(
                "v-container",
                { staticClass: "ma-0 pt-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12 pt-0 ma-0" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "ma-0 pa-4" },
                            [
                              _c(
                                "v-form",
                                { ref: "form1" },
                                [
                                  _c(
                                    "v-card-title",
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "pl-2" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              true
                                                ? _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          attrs: {
                                                            rules: [
                                                              function(v) {
                                                                return (
                                                                  !!v ||
                                                                  "Requerido"
                                                                )
                                                              }
                                                            ],
                                                            label: "Sede",
                                                            row: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.DClocation,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.DClocation = $$v
                                                            },
                                                            expression:
                                                              "DClocation"
                                                          }
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "CTDC",
                                                              value: "CARACAS",
                                                              color: "#60BB46"
                                                            }
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "CTDV",
                                                              value: "VALENCIA",
                                                              color: "#60BB46"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pl-2 pr-3",
                                                      attrs: {
                                                        cols: "12",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-menu",
                                                        {
                                                          ref: "menu",
                                                          attrs: {
                                                            "close-delay":
                                                              "1000",
                                                            "return-value":
                                                              _vm.date,
                                                            transition:
                                                              "scale-transition",
                                                            "offset-y": "",
                                                            "max-width":
                                                              "290px",
                                                            "min-width": "290px"
                                                          },
                                                          on: {
                                                            "update:returnValue": function(
                                                              $event
                                                            ) {
                                                              _vm.date = $event
                                                            },
                                                            "update:return-value": function(
                                                              $event
                                                            ) {
                                                              _vm.date = $event
                                                            }
                                                          },
                                                          scopedSlots: _vm._u([
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                return [
                                                                  _c(
                                                                    "v-text-field",
                                                                    _vm._g(
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha del informe",
                                                                          required:
                                                                            "",
                                                                          readonly:
                                                                            "",
                                                                          rules:
                                                                            _vm
                                                                              .rules
                                                                              .defaultRules,
                                                                          clearable:
                                                                            "",
                                                                          "prepend-icon":
                                                                            "mdi-calendar"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.date,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.date = $$v
                                                                          },
                                                                          expression:
                                                                            "date"
                                                                        }
                                                                      },
                                                                      on
                                                                    )
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ]),
                                                          model: {
                                                            value: _vm.menu,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.menu = $$v
                                                            },
                                                            expression: "menu"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-date-picker",
                                                            {
                                                              attrs: {
                                                                type: "month",
                                                                "no-title": "",
                                                                scrollable: "",
                                                                locale: "es",
                                                                color:
                                                                  "rgb(149,193,84)",
                                                                "header-color":
                                                                  "rgb(64,139,56)"
                                                              },
                                                              on: {
                                                                "click:month": function(
                                                                  $event
                                                                ) {
                                                                  _vm.$refs.menu.save(
                                                                    _vm.dateChange(
                                                                      _vm.picker
                                                                    )
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.picker,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.picker = $$v
                                                                },
                                                                expression:
                                                                  "picker"
                                                              }
                                                            },
                                                            [_c("v-spacer")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "6",
                                                        sm: "8",
                                                        md: "5"
                                                      }
                                                    },
                                                    [
                                                      _c("v-file-input", {
                                                        ref: "file",
                                                        attrs: {
                                                          "show-size": "",
                                                          "truncate-length":
                                                            _vm.inputLength,
                                                          counter: "",
                                                          "counter-size-string":
                                                            "",
                                                          label:
                                                            "Seleccionar archivo",
                                                          rules: _vm.fileRules,
                                                          accept: ".pdf"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.onFileChange
                                                        },
                                                        model: {
                                                          value: _vm.file,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.file = $$v
                                                          },
                                                          expression: "file"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "px-0 d-flex justify-center",
                                                      attrs: {
                                                        cols: "6",
                                                        sm: "4",
                                                        md: "3"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "white--text mt-5",
                                                          attrs: {
                                                            color: "green",
                                                            loading:
                                                              _vm.loadingButton
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.uploadFile()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Guardar archivo "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.reportTypeSelected ===
                                          _vm.healthReportId
                                            ? _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "10",
                                                            lg: "9",
                                                            md: "10",
                                                            sm: "2"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "prepend-inner-icon":
                                                                "mdi-magnify",
                                                              label: "Buscar",
                                                              "single-line": "",
                                                              "hide-details":
                                                                "",
                                                              "validate-on-blur":
                                                                ""
                                                            },
                                                            on: {
                                                              keyup: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  !$event.type.indexOf(
                                                                    "key"
                                                                  ) &&
                                                                  _vm._k(
                                                                    $event.keyCode,
                                                                    "enter",
                                                                    13,
                                                                    $event.key,
                                                                    "Enter"
                                                                  )
                                                                ) {
                                                                  return null
                                                                }
                                                                return _vm.getCustomers()
                                                              }
                                                            },
                                                            model: {
                                                              value: _vm.search,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.search = $$v
                                                              },
                                                              expression:
                                                                "search"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "px-0 d-flex justify-center",
                                                          attrs: {
                                                            cols: "2",
                                                            lg: "3",
                                                            md: "2",
                                                            sm: "1"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "white--text mt-5",
                                                              attrs: {
                                                                color: "green",
                                                                disabled:
                                                                  _vm.loadingCustomers
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.getCustomers()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v(" Buscar ")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.reportTypeSelected === _vm.healthReportId
                                ? _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      "show-select": "",
                                      "item-key": "id",
                                      "single-select": _vm.singleSelect,
                                      headers: _vm.headers,
                                      items: _vm.customers,
                                      options: _vm.customerOptions,
                                      "items-per-page": _vm.itemsPerPage[0],
                                      "items-per-page-options":
                                        _vm.itemsPerPage,
                                      "footer-props": {
                                        itemsPerPageOptions: _vm.itemsPerPage,
                                        itemsPerPageText:
                                          "Cantidad de clientes por página",
                                        prevIcon: "",
                                        nextIcon: "",
                                        pageText: ""
                                      },
                                      loading: _vm.loadingCustomers,
                                      "loading-text": _vm.loadingText,
                                      "no-data-text": _vm.noDataText
                                    },
                                    on: {
                                      "update:options": function($event) {
                                        _vm.customerOptions = $event
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "no-data",
                                          fn: function() {
                                            return [
                                              _vm._v("No hay datos disponibles")
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "no-results",
                                          fn: function() {
                                            return [
                                              _vm._v(
                                                " No se encontraron resultados "
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "item.name",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ml-10 text-center"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.name) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "header.name",
                                          fn: function(ref) {
                                            var header = ref.header
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ml-10 text-center"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(header.text) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "tr",
                                                {
                                                  attrs: {
                                                    active: _vm.selected
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.changeCustomer(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "mt-0 pt-0"
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass:
                                                          "mt-0 pt-0",
                                                        attrs: {
                                                          primary: "",
                                                          "hide-details": "",
                                                          "input-value":
                                                            _vm.customerSelected
                                                              .id == item.id
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.changeCustomer(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-right"
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-right"
                                                    },
                                                    [_vm._v(_vm._s(item.rif))]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4124452849
                                    ),
                                    model: {
                                      value: _vm.customerSelected,
                                      callback: function($$v) {
                                        _vm.customerSelected = $$v
                                      },
                                      expression: "customerSelected"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm.reportTypeSelected === _vm.healthReportId
                            ? _c(
                                "div",
                                {
                                  staticClass: "blue-grey lighten-4 ma-0 py-2"
                                },
                                [
                                  _c("v-pagination", {
                                    attrs: {
                                      length: _vm.pages,
                                      "total-visible": 7
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.getCustomers()
                                      }
                                    },
                                    model: {
                                      value: _vm.page,
                                      callback: function($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "success" },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(
            " Se ha cargado el archivo exitosamente (Nombre del archivo: " +
              _vm._s(this.filePath) +
              ") "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(" No se pudo cargar el archivo, por favor intente de nuevo "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.snackbarFieldError,
            callback: function($$v) {
              _vm.snackbarFieldError = $$v
            },
            expression: "snackbarFieldError"
          }
        },
        [
          _vm._v(
            " Para poder cargar el archivo, debe seleccionar la fecha de " +
              _vm._s(
                _vm.title == "Facturación"
                  ? "facturación"
                  : "emisión del informe"
              ) +
              " y seleccionar el archivo deseado "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }